import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class User {
    public isValidated: boolean = false;
}